import { configureStore, combineReducers } from '@reduxjs/toolkit';
import thunk from 'redux-thunk';
// Reducer
import { persistReducer } from 'redux-persist';
import OperatingReducer from '@slice/operating.slice';
import ProductionReducer from '@slice/production.slice';
import AdminReducer from '@slice/adminConfig.slice';
import SelectReducer from '@slice/select.slice';
import OrderManagerReducer from '@slice/orderManager.slice';
import CreateOrderReducer from '@slice/createOrder.slice';
import UserLoginReducer from '@slice/user.slice';
import storage from 'redux-persist/lib/storage';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';

const persistConfig: any = {
  key: 'root',
  storage,
  stateReconciler: autoMergeLevel2,
  whitelist: ['settingMap']
};

// const settingMapPersistConfig = {
//   key: 'settingMap',
//   storage
// };

const orderManagePersistConfig = {
  key: 'orderManage',
  storage,
  whitelist: ['draftOrders', 'listHistoryNotis']
};

const userPersistConfig = {
  key: 'user',
  storage,
  whitelist: ['version', 'language', 'tableSetting', 'role', 'routeData', 'account', 'deviceTokenMessage']
};

const selectPersistConfig = {
  key: 'select',
  storage,
  whitelist: ['activeMenuHeader', 'themeSelected', 'isCollapsedNav']
};

const rootReducer = combineReducers({
  operating: OperatingReducer,
  production: ProductionReducer,
  orderManager: persistReducer(orderManagePersistConfig, OrderManagerReducer),
  createOrder: CreateOrderReducer,
  select: persistReducer(selectPersistConfig, SelectReducer),
  admin: AdminReducer,
  user: persistReducer(userPersistConfig, UserLoginReducer)
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: [thunk]
});

export type RootState = ReturnType<typeof store.getState>;
export default store;
